import { memo } from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import theme from '../../../theme';

type SideBarOpenButtonPropsType = {
	isLogin: boolean;
	handleDrawerOpen: () => void;
};

/**
 * サイドバーを開くボタン
 */
const SideBarOpenButton = (props: SideBarOpenButtonPropsType) => {
	const { isLogin, handleDrawerOpen } = props;

	return (
		<IconButton
			id="sideBarOpenButton"
			disabled={!isLogin}
			onClick={handleDrawerOpen}
			sx={{
				color: theme.palette.common.white,
			}}
		>
			<MenuIcon />
		</IconButton>
	);
};

export const MemoSideBarOpenButton = memo(SideBarOpenButton);

type SideBarCloseButtonPropsType = {
	handleDrawerClose: () => void;
};

/**
 * サイドバーを閉じるボタン
 */
const SideBarCloseButton = (props: SideBarCloseButtonPropsType) => {
	return (
		<IconButton
			id="sideBarCloseButton"
			onClick={props.handleDrawerClose}
			sx={{
				color: theme.palette.common.black,
			}}
		>
			<ChevronLeftIcon />
		</IconButton>
	);
};

export const MemoSideBarCloseButton = memo(SideBarCloseButton);
